import { Component, Input, OnInit, SimpleChanges } from "@angular/core";
import { FConsultaPagosSigeinService } from "../../servicios/f-consulta-pagos-sigein.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { MenuItem, SelectItem } from "primeng/api";
import { FConsultaPagosSigein, FConsultaPagosSigeinInput } from "../../entidades/entidades";

@Component({
  selector: "app-fconsulta-pagos-sigein-grid",
  templateUrl: "./fconsulta-pagos-sigein-grid.component.html",
  styleUrls: ["./fconsulta-pagos-sigein-grid.component.css"],
})
export class FConsultaPagosSigeinGridComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  fConsultaPagosSigein: FConsultaPagosSigein[] = [];
  itemsMenu: MenuItem[];
  columnasTabla: any[];
  loading: boolean = false;
  clonedFConsultaPagosSigein: { [s: string]: FConsultaPagosSigein } = {};
  @Input("idAguaEnvio") idAguaEnvio: number;

  constructor(
   private fConsultaPagosSigeinService: FConsultaPagosSigeinService,
  ) {}

    ngOnChanges(changes: SimpleChanges): void {
      // Este mét odo se activa cada vez que la entrada 'myInput' cambia. 
      if (changes['idAguaEnvio']) {
        if(this.idAguaEnvio != null) this.getAllFConsultaPagosSigein();
      }
    }

  async ngOnInit() {

    // ===============================================================
    //Opciones de la tabla
    // ===============================================================
    // prettier-ignore
    this.columnasTabla = [
      {field: "fechaCobro", header: "Fecha",ordenar: true, styleHeader: "width: 90px;",},
      {field: "periodoPago", header: "Periodo",ordenar: true, styleHeader: "width: 150px;",},
      {field: "folioPago", header: "Folio",ordenar: true, styleHeader: "width: 65px;",},
      {field: "totalPago", header: "Total",ordenar: true, styleHeader: "width: 100px;",},
      {field: "agua", header: "►Agua",ordenar: true, styleHeader: "width: 100px;",}, 
      {field: "aguaDescuento", header: "Descuento",ordenar: true, styleHeader: "width: 100px;",},
      {field: "baseIva", header: "Iva◄",ordenar: true, styleHeader: "width: 80px;",},
      {field: "drenaje", header: "►Drenaje",ordenar: true, styleHeader: "width: 100px;",},
      {field: "drenajeDescuento", header: "Descuento",ordenar: true, styleHeader: "width: 100px;",},
      {field: "drenajeIva", header: "Iva◄",ordenar: true, styleHeader: "width: 80px;",},
      {field: "manejo", header: "►Sane",ordenar: true, styleHeader: "width: 100px;",},
      {field: "manejoDescuento", header: "Descuento",ordenar: true, styleHeader: "width: 100px;",},
      {field: "manejoIva", header: "Iva◄",ordenar: true, styleHeader: "width: 80px;",},
      {field: "infraestructura", header: "►Infraestruct.",ordenar: true, styleHeader: "width: 120px;",},
      {field: "infraDescuento", header: "Descuento",ordenar: true, styleHeader: "width: 100px;",},
      {field: "infraIva", header: "Iva◄",ordenar: true, styleHeader: "width: 80px;",},
      {field: "recargos", header: "Recargos",ordenar: true, styleHeader: "width: 100px;",},
      {field: "convenio", header: "►Convenio",ordenar: true, styleHeader: "width: 100px;",},
      {field: "convenioIntere", header: "Conv Intereses◄",ordenar: true, styleHeader: "width: 150px;",},
      {field: "otrosCargos", header: "►Adicionales",ordenar: true, styleHeader: "width: 110px;",},
      {field: "otrosCargosIva", header: "IVA◄",ordenar: true, styleHeader: "width: 80px;",},  
      {field: "cajeroPago", header: "Cajero",ordenar: true, styleHeader: "width: 300px;",},
      {field: "cajaPago", header: "Caja",ordenar: true, styleHeader: "width: 180px;",},
    ];
  }


 
   
  // prettier-ignore
  async getAllFConsultaPagosSigein() {
    try {
      this.loading = true;
      let aux = new FConsultaPagosSigeinInput;
      aux.idAgua = this.idAguaEnvio;
      const datoRetorno = await this.fConsultaPagosSigeinService.getBusquedas(aux).toPromise();

      for (let index = 0; index < Object.keys(datoRetorno).length; index++) {
        datoRetorno[index].fechaCobro = new Date(datoRetorno[index].fechaCobro);
        this.fConsultaPagosSigein.push(datoRetorno[index]);
      }

    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllFConsultaPagosSigein");
      this.loading = false;
    }
  }
 
}